module.exports = __webpack_public_path__ + "img/how_image2.1f0f6b14.png";